import { PeriodeService } from './../../../../services/periode.service';
import { Periode } from './../../../../models/periode.model';
import { ConsulationRecetteDialogComponent } from './../../../../@theme/components/dialogs/consulationRecetteDialog/consulationRecetteDialog.component';
import { Component, OnInit, Input } from '@angular/core';
import { Recette } from '../../../../models/recette.model';
import { NbDialogService } from '@nebular/theme';
@Component({
  selector: 'ngx-app-recette-item',
  templateUrl: './recette-item.component.html',
  styleUrls: ['./recette-item.component.scss'],
})
export class RecetteItemComponent implements OnInit {
  @Input() recette: Recette;
  periodes: Periode[];
  constructor(private dialogService: NbDialogService, private periodeService: PeriodeService) { 
    this.periodes = [];
  }
  ngOnInit() {
  }

  async getPeriodes(): Promise<void>{
    let periodes = await this.periodeService.getPeriodes(this.recette.id);
    this.periodes = periodes;
    this.open();
  }
  open() {
    this.periodes.sort(function(obj1, obj2){
      return obj1.ordre - obj2.ordre;
    });
    this.dialogService.open(ConsulationRecetteDialogComponent, {
      context: {
        recette: this.recette,
        periodes: this.periodes,
      },
    });
  }
}
